import { useId as P, useRef as y, useState as m, useLayoutEffect as D, useEffect as O } from "react";
import { filterOptions as S } from "../utils/filter.utils.js";
const g = (t) => `list-${t}`, a = (t, h) => `${g(t)}:option-${h}`, V = ({ options: t, getOptionLabel: h, optionFilter: u }) => {
  const r = P(), p = y(), f = y(null), [c, k] = m(null), [d, x] = m(""), o = (e, n, s) => {
    p.current = n, f.current = s, k(e);
  }, I = () => {
    x(""), o(null, void 0, null);
  };
  D(() => {
    const e = p.current;
    f.current === "keyboard" && e && e.scrollIntoView({
      block: "nearest"
    });
  }, [c]), O(() => {
    I();
  }, [t]);
  const l = u ? u(d, t) : S({
    filterValue: d,
    options: t,
    getOptionLabel: h
  }), w = (e, n) => {
    if (l.length < 1) {
      o(null, void 0, null);
      return;
    }
    const s = c;
    if (s === null) {
      o(0, document.getElementById(a(r, 0)) ?? void 0, n);
      return;
    }
    if (e === "next") {
      const i = (s + 1) % l.length;
      o(i, document.getElementById(a(r, i)) ?? void 0, n);
      return;
    } else {
      const i = (s - 1 + l.length) % l.length;
      o(i, document.getElementById(a(r, i)) ?? void 0, n);
    }
  }, v = (e) => {
    switch (e.key) {
      case "ArrowUp": {
        w("prev", "keyboard");
        break;
      }
      case "ArrowDown": {
        w("next", "keyboard");
        break;
      }
    }
  }, b = (e) => {
    x(e.target.value), o(null, void 0, null);
  }, B = (e) => {
    (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault();
  };
  return {
    highlightIndex: c,
    filteredOptions: l,
    getSearchBoxProps: () => ({
      type: "text",
      autoComplete: "off",
      autoCapitalize: "none",
      spellCheck: !1,
      "aria-controls": g(r),
      value: d,
      onChange: b,
      onKeyDown: B
    }),
    getListProps: () => ({
      id: g(r),
      role: "listbox"
    }),
    getWrapperProps: () => ({
      tabIndex: -1,
      onKeyDown: v
    }),
    getOptionProps: (e) => ({
      id: a(r, e),
      role: "option",
      tabIndex: -1,
      isHighlighted: e === c ? !0 : void 0,
      onPointerMove: (n) => o(e, n.currentTarget, "other")
    }),
    reset: I
  };
};
export {
  g as createListId,
  a as createOptionId,
  V as useSearchList
};
